import { createChatBotMessage } from "react-chatbot-kit";
import SocialMedia from "../SocialMedia/SocialMedia";

const botName = "AnuragBot";

const config = {
  initialMessages: [
    createChatBotMessage(`Hello! Welcome to Anurag's Portfolio, and thanks for visiting. How can I help you today?
    `, {
      widget: "options",
    }),
  ],
  widgets: [
    {
      widgetName: "options",
      widgetFunc: () => <SocialMedia/>
,
    },
  ],
  botName: botName,

  customComponents: {
    // Replaces the default header
    header: () => (
      <div
        style={{ backgroundColor: "#fff", padding: "5px", borderRadius: "3px" }}
      ></div>
    ),
    botAvatar: (props) => (
      <img
        src={"assets/Profiles.jpg"}
        alt="bot avatar"
        style={{
          width: "50px",
          height: "50px",
          borderRadius: "50%",
          marginRight: "10px",
        }}
      />
    ),
  },
  customStyles: {
    botMessageBox: {
      backgroundColor: "#060d2e",
    },
    chatButton: {
      backgroundColor: "#060d2e",
    },
  },
};

export default config;
